<!-- 首页 挽留优惠券底部倒计时 -->
<template>
  <div 
    class="retain-count-down" 
    data-sensors-exposure-event-name="Element_Exposure"  
    data-sensors-exposure-property-caseId="llCouponCountTime"
    :data-sensors-exposure-property-caseBizType="oldPreviewFloatViewResp.caseBizType"
    v-if="showCountDown && !end"
  >
    <span v-if="oldPreviewFloatViewResp.caseBizType === 'OLD_PREVIEW_B'">99%高通资方通道即将失效{{ oldPreviewFloatViewResp.discountType }}，请确认</span>
    <span v-else>您的{{oldPreviewFloatViewResp.discountValue}}<template v-if="oldPreviewFloatViewResp.discountType==='FREE_DAY'">天</template><template v-else>元</template>免息券即将失效，请确认</span>
    <van-count-down
      ref="countDown"
      :time="countDownSeconds"
      @finish="countDownEnd"
      millisecond
    >
      <template #default="timeData">
        {{ timeFormat(timeData.hours) }}:{{ timeFormat(timeData.minutes) }}:{{ timeFormat(timeData.seconds) }}.{{ Math.floor(timeData.milliseconds/100) }}
      </template>
    </van-count-down>
  </div>
</template>

<script>
export default {
  props: {
    oldPreviewFloatViewResp: {}
  },
  data () {
    return {
      end: false
    }
  },
  computed: {
    couponEndTime () {
      return this.oldPreviewFloatViewResp.expTime
    },
    showCountDown () {
      return this.countDownSeconds > 0
    },
    countDownSeconds () {
      return Math.floor((this.couponEndTime - Date.now()))
    }
  },
  methods: {
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    countDownEnd () {
      this.$emit('on-countDownEnd')
    },
    stopCountDown () {
      if (this.$refs?.countDown) {
        this.$refs.countDown.pause()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

 .retain-count-down {
  position: absolute;
  width: 670px;
  height: 116px;
  background: #FEE9E8;
  border-radius: 14px 14px 20px 0px;
  bottom: 96px;
  left:50%;
  transform: translateX(-50%);
  font-size: 26px;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding-left: 40px;
  top:20px;
  padding-top: 16px;
  line-height: 44px;
  .van-count-down{
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #fff;
    line-height: 33px;
    width: 170px;
    height: 44px;
    background: #FF877C;
    border-radius: 25px;
    display: flex;
    padding-left: 18px;
    align-items: center;
    margin-left: 4px;
    margin-right: 25px;
  }
 }
</style>